import { render } from "./RouletteDashboard.vue?vue&type=template&id=33f5237a&scoped=true"
import script from "./RouletteDashboard.vue?vue&type=script&lang=js"
export * from "./RouletteDashboard.vue?vue&type=script&lang=js"

import "./RouletteDashboard.vue?vue&type=style&index=0&id=33f5237a&lang=css"
import "./RouletteDashboard.vue?vue&type=style&index=1&id=33f5237a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f5237a"]])

export default __exports__